import React from 'react'
import { useParams } from 'react-router-dom'

import { CampaignDetailedInfoPage } from './CampaignDetailedInfoPage'

import { useFetch } from 'hooks/useFetch'

import { audienceApi } from 'api/audience-api'
import { campaignsApi } from 'api/campaigns-api'

export const CampaignDetailedInfo = () => {
  const { id } = useParams()

  const { data: campaign, loading } = useFetch({
    getData: () => campaignsApi.getOne(+(id || 0)),
  })
  const { data: rules, loading: rulesLoading } = useFetch({
    getData: () => audienceApi.getRules(),
  })

  return <CampaignDetailedInfoPage campaign={campaign} rules={rules} loading={loading || rulesLoading} />
}
